import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RestaurantServiceService } from '../restaurant-service.service';
import { GenericServiceService } from '../../services/generic-service.service';

@Component({
  selector: 'app-update-restaurant',
  templateUrl: './update-restaurant.component.html',
  styleUrls: ['./update-restaurant.component.scss']
})
export class UpdateRestaurantComponent implements OnInit {
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  tagList: any = [];

  listOfRestaurantsType: any = [];
  restTypeId: any = [];
  id;
  tagsModel: any = [];

  restauranDetail: any = [];
  selectedDetail: any = [];
  selectedTags: any = [];

  countryList: any = [];
  cityList: any = [];
  restTypeModel: any = [];
  config = {
    displayKey: 'Name',
    search: true,
    limitTo: 3
  };
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private restaurantServices: RestaurantServiceService,
    private genericService: GenericServiceService,
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.getAllRestaurnatType();
    this.getAllTags();

    this.EditRestaurant();
    this.getAllCountries();
  }
  getAllCountries() {
    this.genericService.getAllCountries().subscribe(Response => {
      this.countryList = Response;
    });
  }
  getAllTags() {
    this.genericService.getAllTags().subscribe(Response => {
      this.tagList = Response;
      console.log('taglist', this.tagList);
    });
  }
  city(id) {
    this.genericService.getCitWithId(id).subscribe(Response => {
      this.cityList = Response;
    });
  }

  EditRestaurant() {
    this.restaurantServices.getRestaurantbyId(this.id).subscribe(Response => {
      this.restauranDetail = Response.Restaurant;
      this.selectedDetail = Response.RestaurantType;
       console.log('it is updation', Response);
    });
  }
  onSubmit() {
    for (let i = 0; i < this.restTypeModel.length; i++) {
      this.restTypeId.push(this.restTypeModel[i]['Id']);
    }
    this.restauranDetail.RestaurantTypeId = this.restTypeId;
    this.restaurantServices.UpdateResturant(this.restauranDetail).subscribe((Data: any) => {
      console.log(Data);
      if (!Data.hasError) {
        this.toastr.success('Resturant updated');
        this.router.navigateByUrl('/restaurant');
      }

    }, error => {
      this.toastr.success(error.error.Message);
    });
  }

  getAllRestaurnatType() {
    this.restaurantServices.getAllRestaurantsType().subscribe(Response => {
      this.listOfRestaurantsType = Response;
    });
  }

}
